import { MenuItem } from '@mui/material';
import { ActionsMenu, TixlyIconButton, useIsMobile } from '@tix-ticketing/ui-components';
import { CartAddIcon, MoreIcon } from '@tix-ticketing/ui-icons/outline';
import { useIntl } from 'react-intl';
import { useEventProductsAdd } from 'components/cart/use-event-products-add';
import { useProductTexts } from 'lib/hooks/use-product-texts';

/**
 * The actions menu in an event's ticket header in the cart. Renders nothing
 * while it would hold no action.
 */
export function CartEventActions({
  eventId,
  inAside,
  allowAdd
}: {
  eventId: number;
  inAside: boolean;
  allowAdd: boolean;
}) {
  const intl = useIntl();
  const isMobile = useIsMobile();
  const {
    addText
  } = useProductTexts(eventId);
  const {
    addProducts
  } = useEventProductsAdd(eventId, allowAdd);
  if (!addProducts) return null;
  return <ActionsMenu button={<TixlyIconButton data-testid="cart-event-actions" color="monochrome" variant="outlined" size={isMobile || inAside ? 'small' : 'medium'} aria-label={intl.formatMessage({
    id: "common.actions",
    defaultMessage: [{
      "type": 0,
      "value": "Actions"
    }]
  })}>
          <MoreIcon />
        </TixlyIconButton>}>
      <MenuItem data-testid="cart-event-add-products" onClick={addProducts}>
        <CartAddIcon />
        {addText}
      </MenuItem>
    </ActionsMenu>;
}